var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgMov = function SvgMov(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E8BC4",
    fillRule: "evenodd",
    d: "M9 0h7l6 6v15a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0v4a2 2 0 0 0 2 2h4z",
    opacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 8,
    x: 2,
    y: 13,
    fill: "#F7F8FA",
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E8BC4",
    d: "M3.5 15.053h1.105l.936 2.41h.044l.937-2.41h1.104v3.894h-.868v-2.392h-.03l-.887 2.367h-.555l-.887-2.38h-.03v2.405H3.5zM12.173 17q0 .642-.235 1.09a1.64 1.64 0 0 1-.634.678 1.74 1.74 0 0 1-.893.232q-.498 0-.896-.234a1.66 1.66 0 0 1-.632-.678Q8.65 17.64 8.65 17q0-.642.233-1.09.234-.445.632-.678.399-.232.896-.232.495 0 .893.232.4.232.634.679.235.446.235 1.089m-.912 0q0-.38-.103-.643a.84.84 0 0 0-.292-.397.76.76 0 0 0-.455-.135.77.77 0 0 0-.456.135.85.85 0 0 0-.294.397q-.1.263-.1.643t.1.643a.85.85 0 0 0 .294.397.77.77 0 0 0 .456.135q.266 0 .455-.135a.84.84 0 0 0 .292-.397q.103-.263.103-.643M13.82 15.053l.826 2.852h.03l.826-2.852h.998l-1.245 3.894h-1.187l-1.245-3.894z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMov);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;